import { AssessmentHistory, AssignmentItem } from "@/interface/viewClass";
import { API_BASE_URL } from "@/utils/api";

export const mappedData = async (userId: number) => {
  const response = await fetch(`${API_BASE_URL}/quiz/history/${userId}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });

  const rawData = await response.json();

  const mappedData: AssignmentItem[] = rawData.map(
    (item: AssessmentHistory) => {
      const dateObj = new Date(item.createdAt);
      const formattedDate =
        dateObj.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        }) +
        " • " +
        dateObj.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });

      return {
        id: item.id,
        title: item.quizTitle || "Placement Test",
        type: "Assessment",
        deadline: formattedDate,
        status: "Done",
        grade: item.score,
        notes:
          item.score >= 80
            ? "Good Job!"
            : item.score >= 60
              ? "Keep up the good work!"
              : "Needs Improvement",
        action: "Result",
      };
    },
  );

  mappedData.sort(
    (a, b) => new Date(b.deadline).getTime() - new Date(a.deadline).getTime(),
  );

  return mappedData;
};
